import { createI18n } from "vue-i18n";
import { en } from "@/lang/en";
import { ca } from "@/lang/ca";
import { es } from "@/lang/es";
import { he } from "@/lang/he";
import { pt } from "@/lang/pt";
import { ja } from "@/lang/ja";
import { fr } from "@/lang/fr";

const messages = {
  en,
  ca,
  es,
  he,
  pt,
  ja,
  fr
};

export type AppLocale = "en" | "ca" | "es" | "he" | "pt" | "ja" | "fr";

export const i18n = createI18n({
  locale: "en",
  fallbackLocale: "en",
  messages
});
